import React, { Component } from 'react'
import { connect } from 'react-redux'
import composeHOC from 'shared/utils/composeHOC'
import Meta from 'components/layout/Meta';
import preload from 'components/enhancer/preload'
import { actions } from './redux'
import './index.scss'
import classnames from "classnames";

class SubmitForm extends Component {

  constructor(props) {
    super(props)
    this.state = {
      phoneValidMsg:'', telephoneMsg: false, telephoneTips: false,
      nameMsg:'',companyMsg:'',showSucc:false,showError:false,
      mailMsg: false, mailTips: false
    }
  }

  componentDidMount() {

  }

  handleOnChange(event){
    const value = event.target.value;
    const name = event.target.name;
    this.setState({[name] : value, [name + 'Msg']: ''})
  }

  telephoneOnChange(event){
    const value = event.target.value;

    if(/^1\d{10}$/.test(value)) {
      this.setState({phoneValidMsg: '', telephone: value, telephoneTips: true})
      return true;
    }

    this.setState({ phoneValidMsg: '请填写正确手机号码格式', telephoneTips: false });

  }

  mailOnChange(event){
    const value = event.target.value;

    if(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
      this.setState({mailValidMsg:'', mail: value, mailTips: true})
      return true;
    }

    this.setState({ mailValidMsg: '请填写正确格式邮箱' , mailTips: false});
  }

  render() {
    const {nameMsg, telephoneTips, phoneValidMsg,  mailTips, mailValidMsg , contentMsg, showSucc, showError } = this.state;

    return (
      <div className="servicesWrap">
        <Meta location={this.props.location} title=""/>
        <div className="wrap_form">
          <h3>方案咨询</h3>
          <p>请如实填写如下申请信息，我们会根据您提供的联系方式及需求细节派专人与您联系，谢谢配合！</p>
          <form className="form">
            <div>
              <span className="label"><img src={require('./images/stars_icon.png')}/> 姓名:</span>
              <div className="form_input">
                <input type="text" name="name" onChange={(e)=>{  this.handleOnChange(e)}}/>
                <p className="error_msg">{nameMsg}</p>
              </div>
            </div>
            <div>
              <span className="label"><img src={require('./images/stars_icon.png')}/> 电话:</span>
              <div className="form_input">
                <input className={classnames({'select': telephoneTips })} type="text" name="telephone" maxLength="11" onChange={(e)=>{  this.telephoneOnChange(e)} }/>
                {
                  telephoneTips ? <div className="tips"></div> : null
                }
                <p className="error_msg">{phoneValidMsg}</p>
              </div>

            </div>
            <div>
              <span className="label"><img src={require('./images/stars_icon.png')}/> 邮箱:</span>
              <div className="form_input">
                <input className={classnames({'select': mailTips })} type="text" name="mail" onChange={(e)=>{  this.mailOnChange(e)} }/>
                {
                  mailTips ? <div className="tips"></div> : null
                }
                <p className="error_msg">{mailValidMsg}</p>
              </div>
            </div>
            <div>
              <span className="label">企业名称:</span>
              <div className="form_input">
                <input type="text" name="company" onChange={(e)=>{  this.handleOnChange(e)}}/>
              </div>
            </div>
            <div>
              <span className="label">所属行业:</span>
              <select name="sector" onChange={(e)=>{  this.handleOnChange(e)}}>
                <option>--请选择所属行业--</option>
                <option>网站</option>
                <option>移动APP</option>
                <option>IT与软件开发</option>
                <option>新闻媒体</option>
                <option>通讯社交</option>
                <option>电子商务</option>
                <option>通讯社交</option>
                <option>游戏</option>
                <option>音视频</option>
                <option>金融</option>
                <option>教育</option>
                <option>医疗健康</option>
                <option>旅游</option>
                <option>物联网</option>
                <option>汽车业/车联网</option>
                <option>O2O</option>
                <option>电力/新能源</option>
                <option>交通运输</option>
                <option>生产制造</option>
                <option>建筑/地产</option>
                <option>政府/事业单位</option>
                <option>基因</option>
                <option>新零售/烟草业</option>
                <option>物流邮政</option>
                <option>运营商</option>
                <option>能源重工</option>
                <option>公共事业/城市服务</option>
                <option>其他</option>
              </select>
            </div>
            <div>
              <span className="label">职位:</span>
              <select name="position" onChange={(e)=>{  this.handleOnChange(e)}}>
                <option>--请选择职位--</option>
                <option>高级管理人员（CXO）</option>
                <option>CIO/CTO/技术副总裁/总工程师</option>
                <option>业务线负责人</option>
                <option>政府及事业单位管理人员</option>
                <option>技术总监/研发总监</option>
                <option>产品总监/产品经理</option>
                <option>技术经理/研发经理</option>
                <option>项目经理</option>
                <option>IT顾问</option>
                <option>架构师</option>
                <option>IT运维</option>
                <option>开发者</option>
                <option>运营</option>
                <option>学生</option>
                <option>其他</option>
              </select>
            </div>
            <div>
              <span className="label">企业规模:</span>
              <select name="enterprise_size" onChange={(e)=>{  this.handleOnChange(e)}}>
                <option>--请选择企业规模--</option>
                <option>1-49人</option>
                <option>50-99人</option>
                <option>100-499人</option>
                <option>500-2499人</option>
                <option>2500-9999</option>
                <option>10000人及以上</option>
              </select>
            </div>
            <div>
              <span className="label"><img src={require('./images/stars_icon.png')}/> 你想咨询的问题是什么:</span>
              <div className="form_input">
                <textarea name="content" onChange={(e)=>{  this.handleOnChange(e)}}></textarea>
                <p className="error_msg">{contentMsg}</p>
              </div>
            </div>
            <div>
              <button type="button" onClick={this.submitForm.bind(this)} >提交</button>
            </div>
          </form>
        </div>


        {
          showSucc ? (
            <div className="tips_body">
              <div className="tips_box">
                <img src={require('./images/sucess_icon.png')}/>
                <p>信息提交成功，感谢您的反馈!</p>
              </div>
            </div>
          ) : null
        }

        {
          showError ? (
            <div className="tips_body">
              <div className="tips_box">
                <img src={require('./images/error_icon.png')}/>
                <p>信息提交失败，请重新提交信息</p>
              </div>
            </div>
          ) : null
        }

      </div>
    )
  }


  submitForm(){
    const { name, telephone, mail, company, sector, position, enterprise_size, content } = this.state;

    const values = {
      name, telephone, mail, company, sector, position, enterprise_size, content
    }

    if(name == undefined){
      this.setState({nameMsg: '姓名不能为空'})
      return true;
    }
    if(telephone == undefined){
      this.setState({phoneValidMsg: '电话不能为空'})
      return true;
    }
    if(telephone == undefined){
      this.setState({mailValidMsg: '邮箱不能为空'})
      return true;
    }
    if(content == undefined){
      this.setState({contentMsg: '咨询的问题不能为空'})
      return true;
    }

    this.props.submit(values)
    .then(res => {
      this.setState({showSucc: true})
      setTimeout(()=>{
        history.back(-1);
      },3000)
    }).catch(error => {
      this.setState({showError: true})
      setTimeout(()=>{
        this.setState({showError: false})
      },3000)
    })
  }
}

export default composeHOC(
  connect(state => ({
  }), {
    submit: actions.submit
  }),
  preload(({dispatch, location}) => {
  })
)(SubmitForm)




// WEBPACK FOOTER //
// ./modules/services/SubmitForm.js